import Model from "../Model";

export default class extends Model {
    async loadTable(
      page,
      per_page,
      search = '',
      brand_id = null,
      client_id = null,
      device_type_id = null,
      device_os_id = null,
      device_version_id = null,
      date = null,
      currentSortColumn = null,
      currentSortOrder = null
    ) {
        let lastPage = 1;

        let response = await axios.get(this.urls.list, {
            params: {
                page,
                per_page,
                search,
                brand_id,
                client_id,
                device_type_id,
                device_os_id,
                device_version_id,
                date,
                currentSortColumn,
                currentSortOrder
            }
        }).then(response => {

            lastPage = response.data.meta.last_page;

            if(response.data.data !== undefined)
            {
                if(response.data.data.length > 0)
                {
                    return response.data;
                }
            }
            return false;
        });

        let result = {
            tbody: [],
            pages: lastPage,
        };

        if(response.data !== undefined && response.data.length > 0)
        {
            response.data.forEach(download_log => {
                let telem = {
                    tbody: {}
                };
                telem.id = download_log.id;
                telem.tbody.completed_at = download_log.completed_at;
                telem.tbody.finished_at = download_log.finished_at;
                telem.tbody.message = download_log.message;
                telem.tbody.version_number = download_log.device_deployment_assignment.device_release.device_software_version.full_version;
                telem.tbody.status_description = download_log.status.description;
                telem.tbody.status_color = download_log.status.color;
                telem.tbody.location_number = download_log.device_deployment_assignment.device.location.number;
                telem.tbody.brand = download_log.device_deployment_assignment.device.location.brand.name;
                telem.tbody.client = download_log.device_deployment_assignment.device.location.client.name;
                telem.tbody.device_type = download_log.device_deployment_assignment.device.type.name;
                telem.tbody.os = download_log.device_deployment_assignment.device.device_operating_system.name;
                telem.tbody.device_ip = download_log.device_deployment_assignment.device.ip;
                result.tbody.push(telem);
            });
        }
        return result;
    }
}
